import { ORDER_TYPES } from '@/constants/order_types';

export default {
  data() {
    return {
      useNullableOrderType: false,
    };
  },
  computed: {
    orderTypesItems() {
      const items = [];
      if (this.useNullableOrderType) {
        // items.push({
        //   text: this.lang(this.$store, 'sap/listings.global.filter.statuses.all'),
        //   value: null,
        // });
      }
      Object.keys(ORDER_TYPES)
        .forEach((key) => {
          items.push({
            text: this.lang(this.$store, `sap/listings.global.filter.order_types.${ORDER_TYPES[key]}`),
            value: ORDER_TYPES[key],
          });
        });
      return items;
    },
  },
};
